import { useMutation } from 'react-query';
import { RequestTwoFactorLoginValues, requestTwoFactorLogin } from '../../api';

export const useRequestTwoFactorLogin = () => {
  return useMutation(
    (values: RequestTwoFactorLoginValues) => requestTwoFactorLogin(values),
    {},
  );
};
